export default __webpack_public_path__ + "static/media/Check-Example.08aceee5.svg";